var exports = {
  "nf": "x52a3aa3b--0978e2--link",
  "q3": "x52a3aa3b--0978e2--indicator",
  "FV": "x52a3aa3b--0978e2--dropdown-link",
};

module.exports = exports;
